import { Toast } from "@tandemdiabetes/sugarmate-react-components"
import { usePolyglot } from "src/contexts"

interface Props {
  id: string;
  email: string;
}

export function InviteFollowerSuccessToast(props: Props) {
  const {
    id, email,
  } = props

  const polyglot = usePolyglot()

  return (
    <Toast
      stylePreset="success"
      body={polyglot.t(
        "toasts.invite_follower_success.body",
        { email },
      )}
      id={id}
    />
  )
}